import { Input } from "antd"
import ErrorMessage from "components/base/error-message"
import { useFormikContext } from "formik"
import { useEffect, useRef, useState } from "react"

interface TextFieldComponentProps extends React.ComponentProps<typeof Input> {
  name: string
  placeholderValue?: string
  autoFocusPopover?: boolean
  autoFocusDelay?: number
}

const TextField = (props: TextFieldComponentProps) => {
  const { 
    name,
    placeholderValue,
    autoFocusPopover,
    autoFocusDelay,
    ...inputProps
  } = props

  const inputRef = useRef(null)

  const formik = useFormikContext()
  const field = formik.getFieldProps(name)

  const [value, setValue] = useState(field.value)

  // Handle placeholder logic for consistency
  const getUndefineValueForPlaceholder = (val: string) => {
    return placeholderValue && placeholderValue === val ? undefined : val
  }

  useEffect(() => {
    setValue(getUndefineValueForPlaceholder(field.value))
  }, [field.value])

  useEffect(() => {
    if (autoFocusPopover) {
      setTimeout(() => {
        !!inputRef.current && inputRef.current.focus()
      }, autoFocusDelay || 500)
    }
  }, [])

  const errorMsg = !!formik.errors ? formik.errors[name] : ''

  return (
    <>
      <Input
        ref={inputRef}
        {...inputProps}
        value={value}
        onChange={(e) => {
          const inputValue = e.target.value
          setValue(getUndefineValueForPlaceholder(inputValue))
          formik.setFieldValue(field.name, getUndefineValueForPlaceholder(inputValue))
        }}
      />
        <ErrorMessage msg={errorMsg} />
    </>
  )
}

export default TextField
